// extracted by mini-css-extract-plugin
export default {"large":"IBflp","small":"o1AJh","sizeGuideButton":"dTL_Y"};